<template>
  <v-app>
    <div class="animated fadeIn">

      <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

      <ddoClientList :loading="loading" :level="levels[0]" 
          :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks"
          :customSlotNames="levels[0].customSlotNames"
          @loading="refresh_loading"
          @row="refresh_row"
          @childKey="refresh_childKey"
          @errors="refresh_errors"
         >

         <template v-slot:dialogform="{ row, level }">
         <CardUpdatableSla ref="myCardUpdatable" :row="levels[0].row" :depth="levels[0].level" :level="levels[0]"
            @errors="refresh_errors"
         />
         </template>

          <template slot="searchengine" slot-scope="props">
            <p>{{ $t('subtitles.sla_computed') }} :
              <b-radio-group id="sla_computed" v-model="levels[0].searchValues.sla_computed" label="Calculé/Saisi" @change="filter_rows(0)">
                <b-radio value="all">Tous</b-radio>
                <b-radio value="true">Calculé</b-radio>
                <b-radio value="false">Saisi</b-radio>
              </b-radio-group>
             </p>
          </template>

         <template slot="sla_active" slot-scope="props">
            <b-checkbox disabled v-model="props.row.sla_active">{{ $t('texts.sla_active') }}</b-checkbox>
            <b-checkbox disabled v-model="props.row.sla_positive">{{ $t('texts.sla_positive') }}</b-checkbox>
            <b-checkbox disabled v-model="props.row.sla_computed">{{ $t('texts.sla_computed') }}</b-checkbox>
         </template>
         
         <template slot="sla_event_start" slot-scope="props">
            {{ $api._d(props.row.sla_event_start,'long') }}<br/>
            {{ $api._d(props.row.sla_event_stop,'long') }}<br/>
            <strong>{{ $t('texts.sla_duration') }} :</strong> {{ props.row.sla_event_duration }}
         </template>
         
         <template v-slot:child_row="{ props }">
         </template>

         <template v-slot:superheader="{ errors }">
            <h2>{{ $t('titles.sla') }}</h2>
         </template>

      </ddoClientList>

    </div>
  </v-app>
</template>

<script>
import i18n from '@/plugins/i18n.js';
import BasicList from '@/views/BasicList.vue';
import { Event } from '@/components/ddoClientList.vue';

import CardUpdatableSla from '@/components/partials/CardUpdatableSla.vue';

let initial_row = {}

export default {
   name: 'sla',
   mixins: [BasicList],
   components: {
      CardUpdatableSla,
   },
   data: () => {
      return {
         _this: null,
         loading: false,

         /* 
         * LEVEL 1 : all for ddoClientList : columns, options, callbacks
         */
         levels: [

            {
               api_code: 'sla',
               api_prefix: 'sla',
               row: { sla_code: null, vla_desc: null },
               level: 0,
               errors: [],
               columns: [ '_actions', 'sla_name', 'sla_active', 'sla_event_start', 'cus_name', 'plf_name', '_update'],
               customSlotNames: ['sla_active','sla_event_start'],
               searchValues: {
                  sla_computed: null,
               },
               options: {
                  showChildRowToggler: false,
                  withChild: false,
                  hiddenColumns: [],
                  headings: {
                     _pk: i18n.t('headers.actions'),
                     sla_name: i18n.t('headers.code'),
                     sla_active: i18n.t('headers.name'),
                     sla_event_start: i18n.t('headers.sla_event_start'),
                     cus_name: i18n.t('headers.cus_name'),
                     plf_name: i18n.t('headers.plf_name'),
                     _update: i18n.t('headers.updated_on')
                  },
                  texts: {
                  },
                  uniqueKey: 'sla_pk',
                  sortable: [],
                  filterable: false,
                  sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                  columnsDropdown: false,
                  pagination: {
                     chunk: 5,
                     edge: false,
                     nav: 'scroll'
                  },
                  columnsDisplay: {
                     _update: 'desktop',
                     vla_desc: 'desktop',
                     vla_pk: 'desktop',
                  },
                  customFilters: [{
                     name: 'search',
                     callback: function (row, query) {
                        let $ret = true;
                        if ( $ret && query.sla_computed != "all" ) {
                           if ( query.sla_computed=="false" ) { query.sla_computed=false; }
                           if ( query.sla_computed=="true"  ) { query.sla_computed=true; }
                           if ( query.sla_computed==true && !row.sla_computed ) { $ret = false; }
                           if ( query.sla_computed==false && row.sla_computed ) { $ret = false; }
                        }
                        console.log('callback, row='+JSON.stringify(row)+', ret='+$ret);
                        return $ret;
                     }
                  }],
               },
               callbacks: {
               },
               dialogOptions: {
                  codeRules : [
                     (v) => !!v || i18n.t('texts._required')
                  ]
               },
               dialogValues: {
                  headers: {
                     create: i18n.t('texts.sla_create_title'),
                     update: i18n.t('texts.sla_update_title'),
                     delete: i18n.t('texts.sla_delete_title'),
                  },
                  macros: [],
                  samePLF: true,
                  dialogShow: false,
                  form_disabled: false,
                  form_close: true,
                  form_create: false,
                  form_update: false,
                  form_delete: false,
                  header_value_function: function(row) { return row['sla_name']; }
               },
            },

         ],

         useVuex: false,
         theme: 'bootstrap4',
         template: 'default',
      }
   },

   created() {
      this._this = this;
      this.levels[0].callbacks.configure_form  = this.configure_form;
      this.levels[0].callbacks.prepare_create  = this.prepare_create;    
      this.levels[0].callbacks.prepare_update  = this.prepare_update;    
      this.levels[0].callbacks.prepare_delete  = this.prepare_delete;    
      this.levels[0].callbacks.show_dialog     = this.show_dialog;
      this.levels[0].callbacks.refresh_errors  = this.refresh_errors;
      this.levels[0].callbacks.filter_rows     = this.filter_all_rows;
      this.levels[0].searchValues.sla_computed = false;
   },

   async mounted() {
      this.filter_rows(0);
      
   },

   methods: {

      filter_rows(level) {
         Event.$emit('vue-tables.filter::search', this.levels[level].searchValues);
      },

      refresh_errors(level,errors) {
         this.levels[level].errors = errors;
      },

      prepare_create(parentKey=null,origin=null) {
         this.levels[0].errors = [];
         this.$refs.myCardUpdatable.PLFoptions.disabled = false;
         this.$refs.myCardUpdatable.CUSoptions.disabled = false;
         this.$refs.myCardUpdatable.PLFoptions.selected  = null;
         this.$refs.myCardUpdatable.CUSoptions.selected = null;
         this.levels[0].row.sla_active   = true;
         this.levels[0].row.sla_positive = false;
         this.levels[0].row.sla_computed = false;
         this.levels[0].row.sla_uuid = '';
      },

      prepare_update(parentKey=null,_pk,row=null,origin=null) {
         this.levels[0].errors = [];
         this.$refs.myCardUpdatable.PLFoptions.disabled = false;
         //this.$refs.myCardUpdatable.PLFoptions.initial  = this.levels[0].row.plf_pk;
         this.$refs.myCardUpdatable.PLFoptions.selected = this.levels[0].row.plf_pk;
         this.$refs.myCardUpdatable.CUSoptions.selected = this.levels[0].row.cus_pk;
         this.$refs.myCardUpdatable.datetimes = this.$api._build_array_of_datetime_for_picker(this.levels[0].row.sla_event_start, this.levels[0].row.sla_event_stop );
      },

      prepare_delete(parentKey=null,_pk,row=null,origin=null) {
         //this.$refs.myCardUpdatable.CRGoptions.selected  = this.levels[0].row.sl_pk;
         this.$refs.myCardUpdatable.PLFoptions.disabled = true;
         this.$refs.myCardUpdatable.CUSoptions.disabled = true;
         this.$refs.myCardUpdatable.PLFoptions.selected = this.levels[0].row.plf_pk;
         this.$refs.myCardUpdatable.CUSoptions.selected = this.levels[0].row.cus_pk;
         this.$refs.myCardUpdatable.datetimes = this.$api._build_array_of_datetime_for_picker(this.levels[0].row.sla_event_start, this.levels[0].row.sla_event_stop );
      },

      configure_form(level,f_disabled,f_create,f_update,f_delete) {
         let _dV = this.levels[level].dialogValues;
         _dV.form_disabled = f_disabled;
         _dV.form_create   = f_create;
         _dV.form_update   = f_update;
         _dV.form_delete   = f_delete;
         this.levels[level].dialogValues = _dV;
      },

      show_dialog(level,show) {
         let _dV = this.levels[level].dialogValues;
         _dV.header_value = _dV.header_value_function(this.levels[level].row);
         _dV.dialogShow   = show;
         this.levels[level].dialogValues = _dV;
      },

   }
}
</script>